<div
    class="column-filter-popover"
    (keydown.escape)="close()">
    <div class="column-filter-popover__header">
        <span class="column-filter-popover__title">{{
            filterKey().label | translate
        }}</span>
        <button
            mat-icon-button
            type="button"
            class="column-filter-popover__close"
            data-testid="column-filter-close"
            [attr.aria-label]="'GLOBAL.BUTTON.CLOSE' | translate"
            (click)="close()">
            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
        </button>
    </div>

    @if (isTextual()) {
        <mat-form-field
            appearance="fill"
            subscriptSizing="dynamic"
            class="column-filter-popover__field">
            <input
                matInput
                #textFilterInput
                type="text"
                autocomplete="off"
                data-testid="column-filter-input"
                [value]="value()"
                [placeholder]="
                    type() === 'date'
                        ? datePlaceholder
                        : ('TABLE.FILTER-COLUMN' | translate)
                "
                (input)="onTextInput($event)"
                (keydown.enter)="close()" />
            @if (value()) {
                <button
                    matSuffix
                    mat-icon-button
                    type="button"
                    data-testid="column-filter-clear"
                    [matTooltip]="'TABLE.CLEAR-FILTER' | translate"
                    [attr.aria-label]="'TABLE.CLEAR-FILTER' | translate"
                    (click)="clear()">
                    <mat-icon fontSet="material-symbols-outlined">
                        delete
                    </mat-icon>
                </button>
            }
        </mat-form-field>
        @if (type() === 'date') {
            <span class="column-filter-popover__hint">{{
                'TABLE.FILTER-DATE-HINT' | translate
            }}</span>
        }
    } @else {
        <mat-radio-group
            class="column-filter-popover__options"
            [value]="value()">
            <mat-radio-button
                color="primary"
                value=""
                data-testid="column-filter-option-none"
                (change)="onOptionSelected('')">
                {{ 'TABLE.NO-FILTER' | translate }}
            </mat-radio-button>
            @for (option of filterKey().options; track option.value) {
                <mat-radio-button
                    color="primary"
                    [value]="option.value"
                    [attr.data-testid]="'column-filter-option-' + option.value"
                    (change)="onOptionSelected(option.value)">
                    {{ option.label | translate }}
                </mat-radio-button>
            }
        </mat-radio-group>
    }
</div>
